import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GetActivePlayersCall} from '../../apis/player';
import {SET_ACTIVE_PLAYERS} from '../../constants/PlayerConstants';
import {GENERIC_ERROR} from '../../constants/ErrorConstants';

function* tryFunction() {
    const response: number[] = yield call(GetActivePlayersCall);
    yield put({type: SET_ACTIVE_PLAYERS, payload: response});
}

export function* getActivePlayersSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction},
        failedType: GENERIC_ERROR,
    };
    yield call(skeletonSaga, sagaPayload);
}
